import React from 'react'
import {
  presenceErrorClass,
} from 'servos/formValidations'
import Card from '../../../commons/Card'
import Checkbox from '../common/Checkbox'
import DriverLicense from './DriverLicense'
import AusPassport from './AusPassport'
import IntPassport from './IntPassport'
import Medicare from './Medicare'

class Documentation extends React.Component {
  render() {
    const {
      firstName,
      lastName,
      errors,
      email,
      mobile,
      handleStateOfIssue,
      handleCountryOfIssue,
      handleDocumentCheckbox,
      handleMedicareMiddlenameOnCard,
      handleMedicareCardColour,
      handleMedicareValidTo,
      handleInput,
      documentationType,
      driverLicenseNumber,
      stateOfIssue,
      intPassportNumber,
      countryOfIssue,
      ausPassportNumber,
      medicareCardNumber,
      medicareRefNumber,
      medicareMiddlenameOnCard,
      medicareCardColour,
      medicareValidTo,
    } = this.props

    return (
      <Card
        iconName='id'
        title='Documentation'
      >
        <div className='card-body'>
          <div className='grey'>
            Please provide one of the documents below to help us verify your identity.
          </div>
          <br/>
          <Checkbox
            id="driverLicenseNumber"
            label="Australian driver's licence"
            onClick={handleDocumentCheckbox}
            savedTypes={documentationType}
          >
            { documentationType.includes('driverLicenseNumber') &&
              <DriverLicense
                id="driverLicenseNumber"
                errors={errors}
                selectedState={stateOfIssue}
                handleStateOfIssue={handleStateOfIssue}
                handleInput={handleInput}
                driverLicenseNumber={driverLicenseNumber}
              />
            }
          </Checkbox>
          <Checkbox
            id="ausPassportNumber"
            label='Australian passport'
            onClick={handleDocumentCheckbox}
            savedTypes={documentationType}
          >
            { documentationType.includes('ausPassportNumber') &&
              <AusPassport
                id="ausPassportNumber"
                handleInput={handleInput}
                errors={errors}
                ausPassportNumber={ausPassportNumber}
              />
            }
          </Checkbox>
          <Checkbox
            id="intPassportNumber"
            label='International passport with an Australian visa'
            onClick={handleDocumentCheckbox}
            savedTypes={documentationType}
          >
            { documentationType.includes('intPassportNumber') &&
              <IntPassport
                id="intPassportNumber"
                selectedCountry={countryOfIssue}
                handleCountryOfIssue={handleCountryOfIssue}
                handleInput={handleInput}
                errors={errors}
                intPassportNumber={intPassportNumber}
              />
            }
          </Checkbox>
          <Checkbox
            id="medicare"
            label='Medicare card'
            onClick={handleDocumentCheckbox}
            savedTypes={documentationType}
          >
            { documentationType.includes('medicare') &&
              <Medicare
                firstName={firstName}
                lastName={lastName}
                errors={errors}
                medicareCardNumber={medicareCardNumber}
                medicareRefNumber={medicareRefNumber}
                medicareMiddlenameOnCard={medicareMiddlenameOnCard}
                medicareCardColour={medicareCardColour}
                medicareValidTo={medicareValidTo}
                handleMedicareMiddlenameOnCard={handleMedicareMiddlenameOnCard}
                handleMedicareCardColour={handleMedicareCardColour}
                handleMedicareValidTo={handleMedicareValidTo}
                handleInput={handleInput}
              />
            }
          </Checkbox>
        </div>
      </Card>
    )
  }
}

export default Documentation;
